import React, {useEffect, useState} from 'react';
import {Dropdown, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';
import moment from 'moment';

import {
    creditsCreateService,
    creditsDeleteService,
    creditsListService,
    creditsUpdateService
} from '../../services/creditsService';
import {Loader} from '../../components/util/Svg';
import Breadcrumb from '../../components/Breadcrumb';
import {jsonData} from '../common/currencyDropdown';


const Credits = () => {
    const [list, setList] = useState([]);
    const [listDropDown, setListDropdown] = useState([]);
    const [loader, setLoader] = useState(true);
    const [createModal, setCreateModal] = useState(false);
    const [credit, setCredit] = useState('');
    const [creditErr, setCreditErr] = useState('');
    const [currencyErr, setCurrencyErr] = useState('');
    const [currency, setCurrency] = useState('');
    const [filterCurrency, setFilterCurrency] = useState('');
    const [amount, setAmount] = useState('');
    const [amountErr, setAmountErr] = useState('');
    const [vatPercent, setVatPercent] = useState('');
    const [vatPercentErr, setVatPercentErr] = useState('');
    const [file, setFile] = useState('');
    const [fileErr, setFileErr] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [currentId, setCurrentId] = useState('');


    const breadcrumb = [
        {link: '', linkText: 'Credits'}
    ]


    const handleClose = () => {
        setCreateModal(false);
        setAmount('');
        setCreditErr('');
        setCredit('');
        setCurrency('');
        setCurrencyErr('');
        setAmountErr('');
        setCurrentId('');

    }


    const getListDropDown = () => {
        let params = `?currency=${filterCurrency?filterCurrency:''}`;
        creditsListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                let myArray=res.data.result
                const arrayUniqueByKey = [...new Map(myArray.map(item =>
                    [item['currency'], item])).values()];

                setListDropdown(arrayUniqueByKey)
            }
        })
    }
    const getList = () => {
        let params = `?currency=${filterCurrency?filterCurrency:''}`;
        creditsListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                setList(res.data.result)
            }
        })
    }


    useEffect(() => {
        getList();
        getListDropDown();
    }, [])


    const handleFileChange = e => {
        setFile(e.target.files[0])
    }


    const handleValidate = () => {
        let validate = true;
        if (credit == '') {
            setCreditErr('Credit is required');
            validate = false
        }
        if (currency == '') {
            setCurrencyErr('Currency is required');
            validate = false
        }

        if (amount == '') {
            setAmountErr('Amount is required');
        }

        return validate;
    }


    const handleSubmit = e => {
        e.preventDefault();
        if (handleValidate()) {
            setIsDisabled(true);
            let params = {};
            let carCount = amount / credit

            params = {
                'creditAmount': credit,
                'creditId': currentId ? currentId : '',
                'carCount': carCount.toFixed(2),
                'currency': currency.toLowerCase(),
                'amount': amount,
                'vatPercent': vatPercent
            }

            let _service = currentId ? creditsUpdateService : creditsCreateService;

            _service(params).then(res => {
                setIsDisabled(false);
                if (res.status) {
                    handleClose();
                    getList();
                    getListDropDown();
                }
            })
        }

    }

    const handleOnChange = (e, type) => {
        setCurrencyErr('')
        if (type == 'currency' && e.target.value.length < 50) {
            setCurrency(e.target.value);
        }
    }

    const handleDelete = creditId => {
        let tempList = list.filter(i => i._id != creditId);
        setList(tempList);
        let params = {creditId}
        creditsDeleteService(params)
    }

    const handleFilter = (e,type,item) => {
        if(type==1){
            setFilterCurrency('')
    }else {
        setFilterCurrency(item.currency)}
    }

    useEffect(() => {
        getList();
    }, [filterCurrency])



    const handleEdit = item => {
        setCreateModal(true);
        setCredit(item.creditAmount);
        setCurrency(item.currency);
        setAmount(item.amount);
        setVatPercent(item.vatPercent);
        setCurrentId(item._id);
    }


    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <input type="text" className="form-control" placeholder="Search"/>
                <i className="fa fa-search"/>

                <button className="btn btn-primary btn-sm">Search</button>
            </div>

            <Breadcrumb breadcrumb={breadcrumb}/>

            <div className="justifydesign d-flex justify-content-between align-content-center page_header">
                <h2>Credits Pack List</h2>
                <span className="btn btn-primary" onClick={() => setCreateModal(true)}>Create</span>
            </div>


            <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
                {loader ? <div className="loader_lg"><Loader/></div> : ''}
                <table className="table user-table table-hover align-items-center">
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Credits</th>
                        <th>Price per credit</th>
                        <th>
                            <Dropdown alignRight>Amount
                            <Dropdown.Toggle className="no_btn"><i className="fa fa-angle-down"/></Dropdown.Toggle>
                                <Dropdown.Menu><Dropdown.Item href="javascript:void(0)" onClick={(e) => handleFilter(e,1,"item")}>ALL</Dropdown.Item>
                                    { listDropDown.length && listDropDown.map((item) =>( <Dropdown.Item href="javascript:void(0)" onClick={(e) => handleFilter(e,2,item)}>{(item.currency).toUpperCase()}</Dropdown.Item>))}

                            </Dropdown.Menu>
                        </Dropdown>
                        </th>
                        <th>Vat (%)</th>
                        <th>Created</th>
                        <th>Action </th>
                    </tr>
                    </thead>
                    <tbody>
                    {list.map((item, i) => (
                        <tr key={item._id}>
                            <td>{i + 1}</td>
                            <td>{item.creditAmount}</td>
                            <td>{item.carCount}</td>
                            <td>{item.amount} {item.currency?(item.currency).toUpperCase():''}</td>
                            <td> {item.vatPercent?(item.vatPercent):''}</td>
                            <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                            <td>
                                <Dropdown alignRight>
                                    <Dropdown.Toggle className="no_btn"><i className="ellipsis-h"/></Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleEdit(item)}>Edit</Dropdown.Item>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleDelete(item._id)}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>


            <Modal
                show={createModal}
                onHide={handleClose}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Credits</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Credits</label>
                            <input
                                className={`form-control ${creditErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                max={"10000000"}

                                value={credit}
                                onChange={e => (setCredit(e.target.value), setCreditErr(''))}
                                placeholder="Enter no. of credit"/>

                            {creditErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{creditErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>

                        <div className="form-group">
                            <label>Currency {}</label>
                            <select
                                className={`form-control ${currencyErr ? 'is-invalid' : ''} rounded-pill`}
                                    value={currency?currency.toUpperCase():''}
                                    // defaultValue={currency}
                                    onChange={(e) => handleOnChange(e, 'currency')}>
                             <option value={""}>Select</option>
                                { jsonData.map(val=>
                                    <option value={val.cc}>{val.name}</option>

                                )
                                }

                            </select>
                            {/*<input*/}
                            {/*    className={`form-control ${currencyErr ? 'is-invalid' : ''} rounded-pill`}*/}
                            {/*    type="text"*/}
                            {/*    value={currency}*/}
                            {/*    onChange={e => (setCurrency(e.target.value), setCurrencyErr(''))}*/}
                            {/*    placeholder="Enter currency"/>*/}

                            {currencyErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{currencyErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>

                        <div className="form-group">

                            <label>Amount</label>
                            <input
                                className={`form-control ${amountErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                value={amount}
                                max={"1000000000"}
                                step="any"
                                onChange={e => (setAmount(e.target.value), setAmountErr(''))}
                                placeholder="Enter amount"/>

                            {amountErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{amountErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>
                        <div className="form-group">

                            <label>Vat Percentage</label>
                            <input
                                className={`form-control ${vatPercentErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                value={vatPercent}
                                max={"1000000000"}
                                step="any"
                                onChange={e => (setVatPercent(e.target.value), setVatPercentErr(''))}
                                placeholder="Enter amount"/>

                            {vatPercentErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{vatPercentErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>


                        <div className="text-center mt-3">
                            <button disabled={isDisabled} type="submit"
                                    className="btn btn-primary rounded-pill pl-5 pr-5">Submit
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Credits;